import { useEffect, useState } from 'react'
import { isMobile, osName, isIE } from 'react-device-detect'
// import { useHistory } from 'react-router'
// import { InputText } from 'primereact/inputtext'
// import { Button } from 'primereact/button'
import Mobile from '../components/mobile/Mobile'
import ieIcon from './../assets/images/ie-edge_chrome_safari.svg'
import ieLogo from './../assets/images/ie-office-free-logo.svg'

const Login = () => {
  const [mobile, setMobile] = useState(isMobile)
  // const [token, setToken] = useState('')
  // const history = useHistory()
  // const [test, setTest] = useState(false)

  useEffect(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('employee')
    localStorage.removeItem('kvkkDisplay')
    localStorage.removeItem('employeePhoto')
    localStorage.removeItem('kvkkDisplay')
    localStorage.setItem('webApiKey', 'empty')
    setMobile(isMobile)
  }, [])

  useEffect(() => {
    if (!isMobile && !isIE) {
      //&& !test
      window.location.assign(process.env.REACT_APP_SSO!)
    } else {
      if (osName === 'iOS') {
        window.location.assign('officefree://')
      }
    }
  }, [mobile])

  // const getToken = () => {
  //   history.push({
  //     pathname: '/accepted',
  //     search: '?token=' + token,
  //   })
  // }

  const ieWarning = () => {
    return (
      <>
        <div className="ie-warning">
          <div className="text-center">
            <img alt="logo" src={ieLogo} />
          </div>
          <h2 className="mt-5 fw-bold text-center">Office Free bu tarayıcı ile çalışmıyor.</h2>
          <h5 className="mt-3 text-center">
            Sorunsuz bir Office Free deneyimi için Microsoft Edge , Chrome veya Safari ile giriş yapmalısın
          </h5>
          <div className="mt-2 text-center">
            <img alt="icons" src={ieIcon} />
          </div>
        </div>
      </>
    )
  }

  // const renderBrowser = () => {
  //   return (
  //     <>
  //       <InputText value={token} onChange={(e) => setToken(e.target.value)} />
  //       <Button onClick={() => getToken()}>Login</Button>
  //     </>
  //   )
  // }

  return isMobile ? <Mobile /> : isIE ? ieWarning() : null // test ? renderBrowser() :
}

export default Login
